import Dashboard from 'components/Dashboard/Dashboard';
import { FC } from 'react';

const MainUserDashboard: FC = () => {
	return <Dashboard />;
};

export default MainUserDashboard;
